import React from "react";
import {Box, FormControl, InputLabel, MenuItem, Select} from "@mui/material";
import {MenuProps} from "../../styles/components/DynamicComponentStyle";
import IconButton from "@mui/material/IconButton";
import {ClearTwoTone} from "@mui/icons-material";
import moment from "moment/moment";

export const FasciaOrariaSelect = ({reservation, selectedFascia, setSelectedFascia, setSelectedAgenda}) => {
    if (!reservation || reservation.length === 0) return null;

    const res = reservation[0]; // C'è sempre un solo elemento
    const fasceOrarie = [];

    for (let i = 1; i <= 49; i++) {
        const postiDisponibili = res[`fascia${i}I`];
        if (postiDisponibili > 0) {
            const minutiTotali = (i - 1) * 15; // Ogni fascia è a intervalli di 15 minuti
            const oraInizio = Math.floor(minutiTotali / 60) + 8; // Partenza dalle 08:00
            const minutiInizio = minutiTotali % 60;
            const oraFine = Math.floor((minutiTotali + 15) / 60) + 8;
            const minutiFine = (minutiTotali + 15) % 60;

            // const label = `${oraInizio}:${minutiInizio.toString().padStart(2, '0')} - ${oraFine}:${minutiFine.toString().padStart(2, '0')} (${res[`fascia${i}Tag`]})`;
            const label = `${oraInizio}:${minutiInizio.toString().padStart(2, '0')} (${res[`fascia${i}Tag`]})`;
            fasceOrarie.push({ key: i, label });
        }
    }

    const buildLabelFasciaOraria = (fascia) => {
        const minutiTotali = (fascia - 1) * 15; // Ogni fascia è a intervalli di 15 minuti
        const oraInizio = Math.floor(minutiTotali / 60) + 8;
        const minutiInizio = minutiTotali % 60;
        const oraFine = Math.floor((minutiTotali + 15) / 60) + 8;
        const minutiFine = (minutiTotali + 15) % 60;

        // return `${oraInizio}:${minutiInizio.toString().padStart(2, '0')} - ${oraFine}:${minutiFine.toString().padStart(2, '0')} (${res[`fascia${fascia}Tag`]})`;
        return `${oraInizio}:${minutiInizio.toString().padStart(2, '0')} (${res[`fascia${fascia}Tag`]})`;
    };


    return (
        <FormControl variant="outlined" fullWidth size="small" margin="dense">
            <InputLabel>Orari disponibili *</InputLabel>
            <Select
                label="Orari disponibili *"
                value={selectedFascia}
                onChange={(e) => {
                    setSelectedFascia(e.target.value);
                    setSelectedAgenda(res.id);
                }}
                MenuProps={MenuProps}
                renderValue={(selected) => (
                    <RenderValue1Line selected={buildLabelFasciaOraria(selected)} clearSelection={() => {
                        setSelectedFascia('');
                        setSelectedAgenda(null);
                    }}/>)}>>
                >
                {fasceOrarie.map((fascia) => (
                    <MenuItem key={fascia.key} value={fascia.key}>
                        {fascia.label}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export const RenderDate1Line = ({selected, clearSelection}) => {
    return (
        <Box style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%'
        }}>
            <Box style={{display: 'flex', flexDirection: 'column', flexGrow: 1}}>
                <span>{moment(selected, "DDMMYYYY")
                    .locale("it")
                    .format("dddd D MMMM YYYY")
                    .replace(/^\w|\s\w/g, (c) => c.toUpperCase())}</span>
            </Box>
            {selected && (
                <IconButton
                    onMouseDown={(e) => e.stopPropagation()}
                    onClick={(e) => {
                        e.stopPropagation();
                        clearSelection();
                    }}
                    size="small"
                    style={{marginRight: 5, alignSelf: 'center'}}
                >
                    <ClearTwoTone/>
                </IconButton>
            )}
        </Box>
    );
};
export const RenderValue1Line = ({selected, clearSelection}) => {
    return (
        <Box style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%'
        }}>
            <Box style={{display: 'flex', flexDirection: 'column', flexGrow: 1}}>
                <span>{selected}</span>
            </Box>
            {selected && (
                <IconButton
                    onMouseDown={(e) => e.stopPropagation()}
                    onClick={(e) => {
                        e.stopPropagation();
                        clearSelection();
                    }}
                    size="small"
                    style={{marginRight: 5, alignSelf: 'center'}}
                >
                    <ClearTwoTone/>
                </IconButton>
            )}
        </Box>
    );
};
export const RenderValue2Line = ({selected, clearSelection}) => {
    return (
        <Box style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%'
        }}>
            <Box style={{display: 'flex', flexDirection: 'column', flexGrow: 1}}>
                <b>{selected.split(';')[0]}</b>
                <span>{selected.split(';')[1]}</span>
            </Box>
            {selected && (
                <IconButton
                    onMouseDown={(e) => e.stopPropagation()}
                    onClick={(e) => {
                        e.stopPropagation();
                        clearSelection();
                    }}
                    size="small"
                    style={{marginRight: 5, alignSelf: 'center'}}
                >
                    <ClearTwoTone/>
                </IconButton>
            )}
        </Box>
    );
};
